import { render, staticRenderFns } from "./DoctorContacts.vue?vue&type=template&id=7d8c3fd6&scoped=true&"
import script from "./DoctorContacts.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorContacts.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DoctorContacts.vue?vue&type=style&index=0&id=7d8c3fd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8c3fd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d8c3fd6')) {
      api.createRecord('7d8c3fd6', component.options)
    } else {
      api.reload('7d8c3fd6', component.options)
    }
    module.hot.accept("./DoctorContacts.vue?vue&type=template&id=7d8c3fd6&scoped=true&", function () {
      api.rerender('7d8c3fd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorContacts/DoctorContacts.vue"
export default component.exports